import * as React from 'react'

import { Container } from '../Container'
import { GraySection } from '../GraySection'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

import techGreetinCustomer from '../../../public/img/tech-greeting-customer.png'
import Image from 'next/image'
import { CtaButton } from './CtaButton'

const defaultItems = [
  'Free inspection, completed in 20 minutes',
  'Let us come to you or meet us at a Valvoline location',
  'Premium parts backed by 2-year / 24,000-mile warranty',
  'Only recommending repairs you actually need',
]

type Props = {
  title?: string
  description?: string
  items?: string[]
  buttonText?: string
}

export const NotYourTypicalProviderSection: React.FC<Props> = ({
  title = 'Not Your Typical Service Provider — Local & Convenient',
  description = 'We offer brake service at home or at select Valvoline locations (by appointment only). High-quality parts, no upsells — just what you need, where you need it',
  items = defaultItems,
  buttonText = 'GET A FREE INSPECTION & QUOTE',
}) => {
  return (
    <GraySection className="py-[5%] xl:py-16 text-center">
      <Container>
        <div className="flex flex-col gap-12 lg:flex-row items-center justify-center">
          <div className="flex flex-col text-left">
            <div>
              <h2 className="title text-2xl sm:text-3xl md:text-4xl">{title}</h2>
              <p className="description">{description}</p>
            </div>
            <div className="flex flex-col">
              {items.map((item) => (
                <div key={item} className=" flex flex-row justify-start items-center">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size="1x"
                    color={'#14d90d'}
                    style={{ borderRadius: '100%', backgroundColor: 'white' }}
                  />
                  <p className="ml-2 mt-1 text-black">{item}</p>
                </div>
              ))}
            </div>
            <div className="pt-5">
              <CtaButton className="w-full lg:w-fit" buttonText={buttonText} href="#" />
            </div>
          </div>

          <div className="w-full max-w-[28rem] max-h-[28rem] lg:max-w-[32rem] lg:max-h-[32rem] relative  ">
            <Image sizes="w-full h-auto" objectFit="cover" width={1024} height={820} src={techGreetinCustomer} />
          </div>
        </div>
      </Container>
    </GraySection>
  )
}
